import "./EmbedRestAPI.css";

const EmbedRestAPI = () => {
  return (
    <div className="embed-restapi-docs">
      <h1 className="embed-restapi-title">Embedding via REST API</h1>

      <p className="embed-restapi-intro">
        You can integrate your chatbot using the REST API. Follow the steps below to obtain the REST client snippets and embed them into your React application.
      </p>

      <h2 className="embed-restapi-step">Step 1: Select Your Bot</h2>
      <p className="embed-restapi-intro">
        Navigate to <strong>Your Bots</strong> in the Xenachat dashboard and select the chatbot you wish to integrate.
      </p>

      <h2 className="embed-restapi-step">Step 2: Access Connect Settings</h2>
      <p className="embed-restapi-intro">
        Click the <strong>Connect</strong> button on the left sidebar, then select the <strong>REST API</strong> option from the top bar to view the code snippets.
      </p>

      <h2 className="embed-restapi-step">Step 3: Copy the REST Client</h2>
      <p className="embed-restapi-intro">
        Copy the following REST client snippet into your project. Save it as <code>"// src/services/chatService.js"</code>.
      </p>

      <pre className="embed-restapi-code">
{`import axios from "axios";

const API_BASE = "https://api.xenachat.com";

export const sendMessage = async (message) => {
  return axios.post(\`\${API_BASE}/message\`, { message });
};`}
      </pre>

      <h2 className="embed-restapi-step">Step 4: Create the Chatbot Component</h2>
      <p className="embed-restapi-intro">
        Create a React component for the chatbot using the REST client. Save it as <code>"// src/components/SimpleChatBot.jsx"</code>.
      </p>

      <pre className="embed-restapi-code">
{`import { useState } from "react";
import { sendMessage } from "../services/chatService";

export default function SimpleChatBot() {
  // Component logic here
}`}
      </pre>

      <h2 className="embed-restapi-step">Step 5: Use the Component</h2>
      <p className="embed-restapi-intro">
        Import and use the chatbot component anywhere in your React app:
      </p>

      <pre className="embed-restapi-code">
{`import SimpleChatBot from "./components/SimpleChatBot";

function App() {
  return <SimpleChatBot />;
}`}
      </pre>
    </div>
  );
};

export default EmbedRestAPI;
